export const defaultState = () => {
  return {
    faqs: {
      isModalActive: false
    },
    sections:{},
    topic: {
      loading: false,
      fetched: false,
      error: null,
      list: []
    },
    topics: [
      // {
      //   id: "getting-started",
      //   title: "academy.gettingStarted",
      //   describes: "academy.gettingStartedDescription",
      //   thumbnail: "https://d1um8515vdn9kb.cloudfront.net/tutorial1.png"
      // },
      // {
      //   id: "about-us-page",
      //   title: "academy.aboutUs",
      //   describes: "academy.aboutUsDescription",
      //   thumbnail: "https://d1um8515vdn9kb.cloudfront.net/tutorial2.png"
      // },
      // {
      //   id: "high-converting-product-pages",
      //   title: "academy.highConverting",
      //   describes: "academy.highConvertingDesciption",
      //   thumbnail: "https://d1um8515vdn9kb.cloudfront.net/tutorial3.png"
      // }
    ],
    loading: false,
    fetched: false,
    playlist: {
      ___count___: 0
    },
    topicID: null,
    error: null,
    onboarding:{
      isModalActive:false
    }
  };
};

const state = defaultState();

export default state;
